/** Cart amounts are already in the selected Shopify Markets currency. */
class CartShippingMessage extends HTMLElement {
  static observedAttributes = ['hidden', 'data-total', 'data-currency', 'data-threshold-gbp', 'data-trigger-percent'];

  connectedCallback() {
    queueMicrotask(() => this.render());
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    // Section morphing also replaces the heading text and hidden attribute.
    // Render after that synchronous update has completed.
    if (this.isConnected) queueMicrotask(() => this.render());
  }

  render() {
    const heading = this.querySelector('[data-shipping-heading]');
    if (!heading) return;

    const currency = this.dataset.currency;
    // Shopify.currency.rate converts the store currency to the presentment currency.
    // These GBP thresholds require a GBP store base; never guess a missing exchange rate.
    const rate = currency === 'GBP' ? 1 : Number(window.Shopify?.currency?.rate);
    const total = Number(this.dataset.total);
    const threshold = Math.round(Number(this.dataset.thresholdGbp) * 100 * rate);
    const trigger = Math.ceil(threshold * Number(this.dataset.triggerPercent) / 100);
    const shouldHide = (currency !== 'GBP' && this.dataset.storeCurrency !== 'GBP') || !currency ||
      !Number.isFinite(rate) || rate <= 0 || !Number.isFinite(total) ||
      !Number.isFinite(threshold) || threshold <= 0 || total < trigger;
    if (this.hidden !== shouldHide) this.hidden = shouldHide;
    if (shouldHide) return;
    this.style.setProperty('--shipping-progress', String(Math.min(1, Math.max(0, total / threshold))));
    this.toggleAttribute('data-shipping-unlocked', total >= threshold);

    if (total >= threshold) {
      heading.textContent = this.dataset.unlocked;
      return;
    }

    // Shopify represents even zero-decimal currencies (e.g. JPY) with two implied decimals.
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency, minimumFractionDigits: 0,
    });
    const digits = formatter.resolvedOptions().maximumFractionDigits;
    const factor = 10 ** digits;
    const amount = Math.ceil((threshold - total) / 100 * factor) / factor;
    heading.textContent = this.dataset.away.replace('[amount]', formatter.format(amount));
  }
}

if (!customElements.get('cart-shipping-message')) {
  customElements.define('cart-shipping-message', CartShippingMessage);
}
